export default {"src":"/_next/static/media/checked_box.0ae6679a.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};